export default "__VITE_ASSET__BEZ_75zW__"